import Highcharts from "react-highcharts";
import moment from "moment";

export const dateTypes = {
  day: "day",
  week: "week",
  month: "month",
  year: "year",
};

function buidIndexesFromEnums(enums) {
  let activeTypes = {};
  let index = 0;
  Object.keys(enums).forEach(function (key) {
    if (enums[key]) {
      activeTypes[key] = index;
      index++;
    }
  }, this);

  return activeTypes;
}

//create a array of length dataLength and values 0
function getEmptyArray(dataLength) {
  return Array.apply(null, { length: dataLength }).map(function () {
    return 0;
  });
}

function getSeries(visibleSeries, selectedRangeType, dataLen) {
  let keysArray = Object.keys(visibleSeries);
  var values = getEmptyArray(keysArray.length);

  keysArray.forEach(function (key) {
    values[visibleSeries[key]] = { data: getEmptyArray(dataLen), name: key };
  }, this);
  return values;
}

function populateSeriesWithData(
  series,
  data,
  selectedRangeType,
  typeIndexes,
  categories,
  from,
) {
  switch (selectedRangeType) {
    case dateTypes.day: {
      data.forEach(function (element) {
        if (typeIndexes[element.Type] >= 0) {
          let label = moment(element.Date).format("DD/MM/YYYY");
          let i = categories.indexOf(label);
          series[typeIndexes[element.Type]].data[i] =
            series[typeIndexes[element.Type]].data[i] + element.Amount.Amount;
        }
      }, this);
      return series;
    }

    case dateTypes.week: {
      data.forEach(function (element) {
        if (typeIndexes[element.Type] >= 0) {
          element.Date.setHours(0, 0, 0, 0);
          from.setHours(0, 0, 0, 0);
          let daysPassed = moment(element.Date).diff(moment(from), "days");
          let i = Math.floor(daysPassed / 7);

          series[typeIndexes[element.Type]].data[i] =
            series[typeIndexes[element.Type]].data[i] + element.Amount.Amount;
        }
      }, this);

      return series;
    }

    case dateTypes.month: {
      data.forEach(function (element) {
        if (typeIndexes[element.Type] >= 0) {
          element.Date.setHours(0, 0, 0, 0);
          from.setHours(0, 0, 0, 0);
          let i = moment(element.Date).diff(moment(from), "months");

          series[typeIndexes[element.Type]].data[i] =
            series[typeIndexes[element.Type]].data[i] + element.Amount.Amount;
        }
      }, this);

      return series;
    }

    default:
      return series;
  }
}

function getCategories(selectedRangeType, dateStart, dateEnd) {
  var from = moment(dateStart);
  var to = moment(dateEnd);
  switch (selectedRangeType) {
    case dateTypes.day: {
      let values = [];
      while (from < to) {
        values.push(from.format("DD/MM/YYYY"));
        from = from.add(1, "days");
      }

      return values;
    }

    case dateTypes.week: {
      let values = [];
      while (from < to) {
        let val = from.format("DD");
        // add only 6 days so the label format is 01-07/01/2000 and the next one will be
        // 08-14/01/2000
        from = from.add(6, "days");

        if (from > to) {
          val += to.format("-DD/MM/YYYY");
        } else {
          val += from.format("-DD/MM/YYYY");
        }
        // add to skipp to the next day so we start the next week
        from = from.add(1, "days");
        values.push(val);
      }

      return values;
    }

    case dateTypes.month: {
      let values = [];
      while (from < to) {
        values.push(from.format("MMM/YYYY"));
        from = from.add(1, "months");
      }

      // i could happen that after going tothe next month {from.add(1, 'months')}
      // from date is now after to but we dont have the month yet in the categories
      // this if solves the problem
      if (from.month() == to.month() && from > to) {
        let lastMonth = from.format("MMM/YYYY");
        if (values[values.length - 1] != lastMonth) {
          values.push(lastMonth);
        }
      }

      return values;
    }

    default:
      return [];
  }
}

// actionTypesToDisplay - a object with information what action types should be dissplayed
// selectedRangeType one of: day - week - month - year
// data - the data from the backend
// dateStart/dateEnd - dates in with the data is fetched
//
export function chartConfig(
  actionTypesToDisplay,
  selectedRangeType,
  transactions,
  dateStart,
  dateEnd,
) {
  // array length of the data series
  let typeIndexes = buidIndexesFromEnums(actionTypesToDisplay);

  //let seriesData = getRangeDates(selectedRangeType, dateStart, dateEnd, Object.keys(typeIndexes).length);

  let categories = getCategories(selectedRangeType, dateStart, dateEnd);
  let series = getSeries(typeIndexes, selectedRangeType, categories.length);

  series = populateSeriesWithData(
    series,
    transactions,
    selectedRangeType,
    typeIndexes,
    categories,
    dateStart,
  );

  return {
    chart: {
      type: "bar",
      height: "800px",
    },
    title: {
      text: "Statistics",
    },
    xAxis: {
      categories: categories,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Orders Values in SEK",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: "kr",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "top",
      x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      backgroundColor:
        (Highcharts.theme && Highcharts.theme.legendBackgroundColor) ||
        "#FFFFFF",
      shadow: true,
    },
    credits: {
      enabled: false,
    },
    series: series,
  };
}

// statistics for all general data
export function getGeneralStatistics(statisticsData, transactions) {
  let statistics = getEmptyStatistics();

  transactions.forEach(function (element) {
    if (element.Type === "Credit" && element.To === "ExternalBank") {
      statistics.paydOut.amount += element.Amount.Amount;
      statistics.paydOut.number += 1;
    } else if (element.Type === "Deposit") {
      statistics.deposits.amount += element.Amount.Amount;
      statistics.deposits.number += 1;
    } else if (element.Type === "Withdrawal") {
      statistics.withdrawals.amount += element.Amount.Amount;
      statistics.withdrawals.number += 1;
    } else if (element.Type === "PreliminaryTax") {
      statistics.accTax += element.Amount.Amount;
    } else if (element.Type === "Principal") {
      statistics.payments.principal += element.Amount.Amount;
    } else if (element.Type === "Interest") {
      statistics.payments.intrest += element.Amount.Amount;
      statistics.payments.number += 1;
    } else if (element.Type === "ServiceFee") {
      statistics.lenderFees += element.Amount.Amount;
    } else if (element.Type === "LateFee" || element.Type === "InvoiceFee") {
      statistics.fees += element.Amount.Amount;
    }
  }, this);

  statisticsData.NewApplications.forEach(function (application) {
    if (application.AssetType === "CCLongTerm") {
      statistics.newApplications.long += 1;
    } else if (application.AssetType === "CCShortTerm") {
      statistics.newApplications.short += 1;
    }
  });

  statisticsData.ApprovedApplications.forEach(function (application) {
    if (application.AssetType === "CCShortTerm") {
      statistics.approvedAppShort.amount += 1;
      statistics.approvedAppShort.number += application.Amount.Amount;
    } else if (application.AssetType === "CCLongTerm") {
      statistics.approvedAppLong.number += 1;
      statistics.approvedAppLong.amount += application.Amount.Amount;
    }
  });

  Object.keys(statisticsData.LoanstepLogins).forEach(function (key) {
    statistics.loanstepLogins += statisticsData.LoanstepLogins[key];
  });
  Object.keys(statisticsData.SavelendLogins).forEach(function (key) {
    statistics.savelendLogins += statisticsData.SavelendLogins[key];
  });

  return statistics;
}

export function getEmptyStatistics() {
  return {
    approvedAppShort: {
      amount: 0,
      number: 0,
    },
    approvedAppLong: {
      amount: 0,
      number: 0,
    },
    newApplications: {
      short: 0,
      long: 0,
    },
    paydOut: {
      amount: 0,
      number: 0,
    },
    newBorrowers: {
      amount: 0,
      number: 0,
    },
    oldBorrowers: {
      amount: 0,
      number: 0,
    },
    newLoanstepUsers: 0,
    loanstepLogins: 0,
    savelendLogins: 0,
    payments: {
      number: 0,
      principal: 0,
      intrest: 0,
      fees: 0,
    },
    newLenders: 0,
    deposits: {
      number: 0,
      amount: 0,
    },
    withdrawals: {
      number: 0,
      amount: 0,
    },
    accTax: 0,
    lenderFees: 0,
    clientBalance: 0,
    outstandingClaim: 0,
  };
}
